import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=2ddbef1c&scoped=true&"
import script from "./Cities.vue?vue&type=script&lang=js&"
export * from "./Cities.vue?vue&type=script&lang=js&"
import style0 from "./Cities.vue?vue&type=style&index=0&id=2ddbef1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbef1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddbef1c')) {
      api.createRecord('2ddbef1c', component.options)
    } else {
      api.reload('2ddbef1c', component.options)
    }
    module.hot.accept("./Cities.vue?vue&type=template&id=2ddbef1c&scoped=true&", function () {
      api.rerender('2ddbef1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Cities.vue"
export default component.exports